//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '~/components/Shared/ModalWithTitleBar.vue'
import Policies from '~/components/Shared/Policies'
export default {
  name: 'ModalPrivacyPolicy',
  components: { ModalWithTitleBar, Policies },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleModal() {
      this.$emit('toggle')
    },
  },
}
